import generateContext, { createAction } from '..';


interface IManageCourierState {
  selectedCourierHash: string[];
  isAllSelected: boolean;
  connectedCourierHash: string[];

}

const initialState: IManageCourierState = {
  selectedCourierHash:  [],
  isAllSelected: false,
  connectedCourierHash: []
};

enum ManageCourierActionType {
  SelectAllCouriers = 'SELECT_ALL_COURIERS',
  SelectCourier = 'SELECT_COURIER',
  FlushSelectedCourierList = 'FLUSH_SELECTED_COURIER_LIST',
  SetConnectedCourier = 'SET_CONNECTED_COURIER_LIST'
}

const reducer = (
  state: IManageCourierState,
  action: { type: ManageCourierActionType; payload?: any }
): IManageCourierState => {
  switch (action.type) {
    case ManageCourierActionType.SelectCourier:
      return {
        ...state,
        selectedCourierHash: action.payload
      };

    case ManageCourierActionType.FlushSelectedCourierList:
      return {
        isAllSelected: false,
        selectedCourierHash: [],
        connectedCourierHash: []
      }

    case ManageCourierActionType.SelectAllCouriers: 
      return {
        ...state,
        isAllSelected: action.payload,
      }
    case ManageCourierActionType.SetConnectedCourier: 
      return {
        ...state,
        connectedCourierHash: action.payload
      }
    default:
      return state;
  }
};

const [ManageCourierCtxProvider, useManageCourierState, useManageCourierDispatch] =
  generateContext(reducer, initialState);

const useManageCourierActions = () => {
  const dispatch = useManageCourierDispatch();

  const addCourierHash = (payload: string[]) => {
    dispatch(createAction(ManageCourierActionType.SelectCourier, payload));
  };

  const setConnectedCourierHash = (payload: string[]) => {
    dispatch(createAction(ManageCourierActionType.SetConnectedCourier,payload))
  }

  const selectAllCouriers = (payload:boolean) => {
    dispatch(createAction(ManageCourierActionType.SelectAllCouriers,payload))
  }

  const flushCourierList = () => {
    dispatch(createAction(ManageCourierActionType.FlushSelectedCourierList))
  }
 
  return {
    addCourierHash,
    flushCourierList,
    selectAllCouriers,
    setConnectedCourierHash
  };
};

export { ManageCourierCtxProvider, useManageCourierState, useManageCourierActions };
